import { VirtualManifestAPI } from '@wix/editor-platform-manifest-services';
import {
  ManifestProcessingStrategy,
  StylesDerivedNativeActionNames,
} from '../../types';
import {
  checkContextMatch,
  isStyleValuePresent,
} from '../../../../apis/services/editActionsServices/nativeActions/globalDesign/common/actionValidators/helpers';
import { getAllowedPropertiesForAction } from '../../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';

export const getBaseManifestProcessingStrategy = (
  actionName: StylesDerivedNativeActionNames,
) => {
  const allowedStyles = new Set<string>(
    getAllowedPropertiesForAction(actionName),
  );

  return (rootContext: VirtualManifestAPI): ManifestProcessingStrategy => {
    return checkContextMatch(rootContext, (context) =>
      isStyleValuePresent(context, allowedStyles),
    )
      ? ManifestProcessingStrategy.Recursive
      : ManifestProcessingStrategy.Root;
  };
};
